import React, { useEffect, useState } from "react";
/// React router dom
import { Link, useLocation } from "react-router-dom";

//images
import logo1 from "./../../../assets/images/logo/logo.png";
import logotext1 from "./../../../assets/images/logo/logo-text.png";
import logoColor from "./../../../assets/images/logo/logo-color.png";
import logoColorText from "./../../../assets/images/logo/logo-text-color.png";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
      console.log("RUNNER IF");
    } else {
      console.log("RUNNER ELSE");
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = ({ defaultMenu = false }) => {
  const [toggle, setToggle] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 771);

  const location = useLocation();
  console.log(location);
  useEffect(() => {
    if (isMobile) {
      setToggle(false);
      let mainwrapper = document.querySelector("#main-wrapper");
      mainwrapper.classList.remove("menu-toggle");
    }
  }, [location?.pathname, isMobile]);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 771);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="nav-header">
      {!toggle && !isMobile ? (
        <Link to="/dashboard" className="brand-logo">
          <img src={logo1} className="logo-abbr" alt="" />
          <img src={logotext1} className="brand-title" alt="" />
          <img src={logoColor} className="logo-color" alt="" />
          <img src={logoColorText} className="brand-title color-title" alt="" />
        </Link>
      ) : (
        !isMobile && (
          <div className="collapsed-icon">
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
            <svg
              style={{ paddingTop: "25px", marginLeft: "20px" }}
              width="45"
              height="50"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="4" width="26" height="2" rx="1" fill="white" />
              <rect y="12" width="26" height="2" rx="1" fill="white" />
              <rect y="20" width="26" height="2" rx="1" fill="white" />
            </svg>
          </div>
        )
      )}

      <div
        className={isMobile ? "nav-wrapper" : "nav-control"}
        onClick={() => {
          setToggle(!toggle);
          NavMenuToggle();
        }}
        style={{
          paddingTop: isMobile ? "20px" : "2px",
          paddingLeft: "19px",
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="4" width="26" height="2" rx="1" fill="#2A353A" />
            <rect y="12" width="26" height="2" rx="1" fill="#2A353A" />
            <rect y="20" width="26" height="2" rx="1" fill="#2A353A" />
          </svg>

          {/* <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect x="22" y="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="22" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="11" y="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="11" y="22" width="4" height="4" rx="2" fill="#2A353A" />
            <rect width="4" height="4" rx="2" fill="#2A353A" />
            <rect y="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="22" y="22" width="4" height="4" rx="2" fill="#2A353A" />
            <rect y="22" width="4" height="4" rx="2" fill="#2A353A" />
          </svg> */}
        </div>
      </div>
    </div>
  );
};

export default NavHader;
